export default __webpack_public_path__ + "static/media/header_faces.7f830762.png";